module.exports = __webpack_public_path__ + "img/472.8c02828f.png";